import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-left: 2.75rem;
`

Wrapper.displayName = 'Wrapper'

export const CommentSuggestionOptions = styled.div`
  gap: var(--spacer-2);
  overflow-x: auto;
  white-space: nowrap;
  position: relative;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

CommentSuggestionOptions.displayName = 'CommentSuggestionOptions'

export const CommentSuggestionOption = styled.button`
  transition: background-color ease 250ms;
  background-color: transparent;
  white-space: nowrap;

  &:hover:not([disabled]) {
    background-color: var(--gray-200);
  }

  &:focus {
    outline: 2px solid var(--blue);
    outline-offset: -2px;
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed !important;
  }
`

CommentSuggestionOption.displayName = 'CommentSuggestionOption'
